[
 {
  "Options": [
   {
    "color": "#3eb75b",
    "key": "EX",
    "name": [
     {
      "key": "EN",
      "name": "Excellent"
     },
     {
      "key": "AR",
      "name": "ممتاز"
     }
    ]
   },
   {
    "color": "#73b504",
    "key": "G",
    "name": [
     {
      "key": "EN",
      "name": "Good"
     },
     {
      "key": "AR",
      "name": "جيد"
     }
    ]
   },
   {
    "color": "#ff9000",
    "key": "F",
    "name": [
     {
      "key": "EN",
      "name": "Fair"
     },
     {
      "key": "AR",
      "name": "مقبول"
     }
    ]
   },
   {
    "color": "#e64e4e",
    "key": "P",
    "name": [
     {
      "key": "EN",
      "name": "Poor"
     },
     {
      "key": "AR",
      "name": "ضعيف"
     }
    ]
   }
  ],
  "key": "rating-liked"
 },
 {
  "Options": [
   {
    "color": "#3eb75b",
    "key": "5",
    "name": [
     {
      "key": "EN",
      "name": "Strongly Agree"
     },
     {
      "key": "AR",
      "name": "أوافق بشدة"
     },
     {
      "key": "ES",
      "name": "Totalmente de acuerdoooooo"
     },
     {
      "key": "FR",
      "name": "Tout à fait d’accord"
     },
     {
      "key": "DE",
      "name": "Stimme sehr zu"
     },
     {
      "key": "NL",
      "name": "Helemaal mee eens"
     },
     {
      "key": "LA",
      "name": "Fortiter consentio"
     },
     {
      "key": "SI",
      "name": "තරයේ එකඟයි"
     },
     {
      "key": "NE",
      "name": "दृढतापूर्वक सहमत"
     },
     {
      "key": "ML",
      "name": "ശക്തമായി സമ്മതിക്കുന്നു"
     },
     {
      "key": "ID",
      "name": "Sangat setuju"
     },
     {
      "key": "HI",
      "name": "दृढ़तापूर्वक सहमत"
     },
     {
      "key": "TA",
      "name": "Lubos na Sumasang-ayon"
     },
     {
      "key": "UR",
      "name": "بہت زیادہ اتفاق"
     },
     {
      "key": "BN",
      "name": "দৃঢ়ভাবে একমত"
     },
     {
      "key": "TR",
      "name": "Kesinlikle Katılıyorum"
     }
    ]
   },
   {
    "color": "#9dc62b",
    "key": "4",
    "name": [
     {
      "key": "EN",
      "name": "Agree"
     },
     {
      "key": "AR",
      "name": "أوافق"
     },
     {
      "key": "ES",
      "name": "De acuerdo"
     },
     {
      "key": "FR",
      "name": "D’accord"
     },
     {
      "key": "DE",
      "name": "Stimme zu"
     },
     {
      "key": "NL",
      "name": "Mee eens"
     },
     {
      "key": "LA",
      "name": "Consentio"
     },
     {
      "key": "SI",
      "name": "එකඟ වෙමි"
     },
     {
      "key": "NE",
      "name": "सहमत छु"
     },
     {
      "key": "ML",
      "name": " അംഗീകരിക്കുന്നു "
     },
     {
      "key": "ID",
      "name": "Setuju"
     },
     {
      "key": "HI",
      "name": "सहमत"
     },
     {
      "key": "TA",
      "name": "Sumang-ayon"
     },
     {
      "key": "UR",
      "name": "متفق"
     },
     {
      "key": "BN",
      "name": "একমত"
     },
     {
      "key": "TR",
      "name": "Katılıyorum"
     }
    ]
   },
   {
    "color": "#ff9000",
    "key": "3",
    "name": [
     {
      "key": "EN",
      "name": "Neutral"
     },
     {
      "key": "AR",
      "name": "محايد"
     },
     {
      "key": "ES",
      "name": "Ni de acuerdo ni en desacuerdo"
     },
     {
      "key": "FR",
      "name": "Neutre"
     },
     {
      "key": "DE",
      "name": "Neutral"
     },
     {
      "key": "NL",
      "name": "Neutraal"
     },
     {
      "key": "LA",
      "name": "Neutrum"
     },
     {
      "key": "SI",
      "name": "මධ්‍යස්ථයි"
     },
     {
      "key": "NE",
      "name": "तटस्थ"
     },
     {
      "key": "ML",
      "name": "നിഷ്പക്ഷമാണ്‌ "
     },
     {
      "key": "ID",
      "name": "Netral"
     },
     {
      "key": "UR",
      "name": "غیر جانبدار"
     },
     {
      "key": "BN",
      "name": "নিরপেক্ষ"
     },
     {
      "key": "HI",
      "name": "तटस्थ"
     },
     {
      "key": "TL",
      "name": "Neutral"
     },
     {
      "key": "TR",
      "name": "Kararsızım"
     }
    ]
   },
   {
    "color": "#ff9000",
    "key": "2",
    "name": [
     {
      "key": "EN",
      "name": "Disagree"
     },
     {
      "key": "AR",
      "name": "لا أوافق"
     },
     {
      "key": "ES",
      "name": "En desacuerdo"
     },
     {
      "key": "FR",
      "name": "Pas d’accord"
     },
     {
      "key": "DE",
      "name": "Stimme nicht zu"
     },
     {
      "key": "NL",
      "name": "Niet mee eens"
     },
     {
      "key": "LA",
      "name": "Dissentio"
     },
     {
      "key": "SI",
      "name": "එකඟ නොවෙමි"
     },
     {
      "key": "NE",
      "name": "असहमत छु"
     },
     {
      "key": "ML",
      "name": " വിയോജിക്കുന്നു "
     },
     {
      "key": "ID",
      "name": "Tidak Setuju"
     },
     {
      "key": "HI",
      "name": "असहमत"
     },
     {
      "key": "TA",
      "name": "Hindi sumasang-ayon"
     },
     {
      "key": "UR",
      "name": "اختلاف کرنا"
     },
     {
      "key": "BN",
      "name": "অসম্মতি"
     },
     {
      "key": "TR",
      "name": "Katılmıyorum"
     }
    ]
   },
   {
    "color": "#e64e4e",
    "key": "1",
    "name": [
     {
      "key": "EN",
      "name": "Strongly Disagree"
     },
     {
      "key": "AR",
      "name": "لا أوافق بشدة"
     },
     {
      "key": "ES",
      "name": "Totalmente en desacuerdo"
     },
     {
      "key": "FR",
      "name": "Pas du tout d’accord"
     },
     {
      "key": "DE",
      "name": "Stimme gar nicht zu"
     },
     {
      "key": "NL",
      "name": "Sterk mee oneens"
     },
     {
      "key": "LA",
      "name": "Fortiter dissentio"
     },
     {
      "key": "SI",
      "name": "දැඩි ලෙස එකඟ නොවේ"
     },
     {
      "key": "NE",
      "name": "कडा असहमत"
     },
     {
      "key": "ML",
      "name": "ശക്തമായി വിയോജിക്കുന്നു"
     },
     {
      "key": "ID",
      "name": "Sangat tidak setuju"
     },
     {
      "key": "HI",
      "name": "दृढ़तापूर्वक असहमत"
     },
     {
      "key": "TA",
      "name": "Lubos na Hindi Sumasang-ayon"
     },
     {
      "key": "UR",
      "name": "بہت زیادہ اختلاف"
     },
     {
      "key": "BN",
      "name": "দৃঢ়ভাবে অসম্মতি"
     },
     {
      "key": "TR",
      "name": "Kesinlikle Katılmıyorum"
     }
    ]
   },
   {
    "color": "#808080",
    "key": "0",
    "name": [
     {
      "key": "EN",
      "name": "N/A"
     },
     {
      "key": "AR",
      "name": "لا ينطبق"
     },
     {
      "key": "ES",
      "name": "N/A"
     },
     {
      "key": "FR",
      "name": "N/A"
     },
     {
      "key": "DE",
      "name": "N/A"
     },
     {
      "key": "NL",
      "name": "N/A"
     },
     {
      "key": "LA",
      "name": "N/A"
     },
     {
      "key": "HI",
      "name": "लागू नहीं"
     },
     {
      "key": "TA",
      "name": "hindi maaari"
     },
     {
      "key": "UR",
      "name": "قابل اطلاق نہیں"
     },
     {
      "key": "BN",
      "name": "প্রযোজ্য নয়"
     },
     {
      "key": "TR",
      "name": "Uygun Değil"
     }
    ]
   }
  ],
  "key": "single-answer-confidence"
 },
 {
  "Options": [
   {
    "color": "#3eb75b",
    "key": "4",
    "name": [
     {
      "key": "EN",
      "name": "Strongly Agree"
     },
     {
      "key": "AR",
      "name": "أوافق بشدة"
     },
     {
      "key": "ES",
      "name": "Totalmente de acuerdo"
     },
     {
      "key": "FR",
      "name": "Tout à fait d’accord"
     },
     {
      "key": "DE",
      "name": "Stimme sehr zu"
     },
     {
      "key": "NL",
      "name": "Helemaal mee eens"
     },
     {
      "key": "LA",
      "name": "Fortiter consentio"
     },
     {
      "key": "SI",
      "name": "තරයේ එකඟයි"
     },
     {
      "key": "NE",
      "name": "दृढतापूर्वक सहमत"
     },
     {
      "key": "ML",
      "name": "ശക്തമായി സമ്മതിക്കുന്നു"
     },
     {
      "key": "ID",
      "name": "Sangat setuju"
     },
     {
      "key": "HI",
      "name": "दृढ़तापूर्वक सहमत"
     },
     {
      "key": "TA",
      "name": "Lubos na Sumasang-ayon"
     },
     {
      "key": "UR",
      "name": "بہت زیادہ اتفاق"
     },
     {
      "key": "BN",
      "name": "দৃঢ়ভাবে একমত"
     }
    ]
   },
   {
    "color": "#9dc62b",
    "key": "3",
    "name": [
     {
      "key": "EN",
      "name": "Agree"
     },
     {
      "key": "AR",
      "name": "أوافق"
     },
     {
      "key": "ES",
      "name": "De acuerdo"
     },
     {
      "key": "FR",
      "name": "D’accord"
     },
     {
      "key": "DE",
      "name": "Stimme zu"
     },
     {
      "key": "NL",
      "name": "Mee eens"
     },
     {
      "key": "LA",
      "name": "Consentio"
     },
     {
      "key": "SI",
      "name": "එකඟ වෙමි"
     },
     {
      "key": "NE",
      "name": "सहमत छु"
     },
     {
      "key": "ML",
      "name": " അംഗീകരിക്കുന്നു "
     },
     {
      "key": "ID",
      "name": "Setuju"
     },
     {
      "key": "HI",
      "name": "सहमत"
     },
     {
      "key": "TA",
      "name": "Sumang-ayon"
     },
     {
      "key": "UR",
      "name": "متفق"
     },
     {
      "key": "BN",
      "name": "একমত"
     }
    ]
   },
   {
    "color": "#ff9000",
    "key": "2",
    "name": [
     {
      "key": "EN",
      "name": "Disagree"
     },
     {
      "key": "AR",
      "name": "لا أوافق"
     },
     {
      "key": "ES",
      "name": "En desacuerdo"
     },
     {
      "key": "FR",
      "name": "Pas d’accord"
     },
     {
      "key": "DE",
      "name": "Stimme nicht zu"
     },
     {
      "key": "NL",
      "name": "Niet mee eens"
     },
     {
      "key": "LA",
      "name": "Dissentio"
     },
     {
      "key": "SI",
      "name": "එකඟ නොවෙමි"
     },
     {
      "key": "NE",
      "name": "असहमत छु"
     },
     {
      "key": "ML",
      "name": " വിയോജിക്കുന്നു "
     },
     {
      "key": "ID",
      "name": "Tidak Setuju"
     },
     {
      "key": "HI",
      "name": "असहमत"
     },
     {
      "key": "TA",
      "name": "Hindi sumasang-ayon"
     },
     {
      "key": "UR",
      "name": "اختلاف کرنا"
     },
     {
      "key": "BN",
      "name": "অসম্মতি"
     }
    ]
   },
   {
    "color": "#e64e4e",
    "key": "1",
    "name": [
     {
      "key": "EN",
      "name": "Strongly Disagree"
     },
     {
      "key": "AR",
      "name": "لا أوافق بشدة"
     },
     {
      "key": "ES",
      "name": "Totalmente en desacuerdo"
     },
     {
      "key": "FR",
      "name": "Pas du tout d’accord"
     },
     {
      "key": "DE",
      "name": "Stimme gar nicht zu"
     },
     {
      "key": "NL",
      "name": "Sterk mee oneens"
     },
     {
      "key": "LA",
      "name": "Fortiter dissentio"
     },
     {
      "key": "SI",
      "name": "දැඩි ලෙස එකඟ නොවේ"
     },
     {
      "key": "NE",
      "name": "कडा असहमत"
     },
     {
      "key": "ML",
      "name": "ശക്തമായി വിയോജിക്കുന്നു"
     },
     {
      "key": "ID",
      "name": "Sangat tidak setuju"
     },
     {
      "key": "HI",
      "name": "दृढ़तापूर्वक असहमत"
     },
     {
      "key": "TA",
      "name": "Lubos na Hindi Sumasang-ayon"
     },
     {
      "key": "UR",
      "name": "بہت زیادہ اختلاف"
     },
     {
      "key": "BN",
      "name": "দৃঢ়ভাবে অসম্মতি"
     }
    ]
   }
  ],
  "key": "single-answer-confidence-no-neutral"
 },
 {
  "Options": [
   {
    "color": "#3eb75b",
    "key": "5",
    "name": [
     {
      "key": "EN",
      "name": "Strongly Agree"
     },
     {
      "key": "AR",
      "name": "أوافق بشدة"
     },
     {
      "key": "ES",
      "name": "Totalmente de acuerdo"
     },
     {
      "key": "FR",
      "name": "Tout à fait d’accord"
     },
     {
      "key": "DE",
      "name": "Stimme sehr zu"
     },
     {
      "key": "NL",
      "name": "Helemaal mee eens"
     },
     {
      "key": "LA",
      "name": "Fortiter consentio"
     }
    ]
   },
   {
    "color": "#9dc62b",
    "key": "4",
    "name": [
     {
      "key": "EN",
      "name": "Agree"
     },
     {
      "key": "AR",
      "name": "أوافق"
     },
     {
      "key": "ES",
      "name": "De acuerdo"
     },
     {
      "key": "FR",
      "name": "D’accord"
     },
     {
      "key": "DE",
      "name": "Stimme zu"
     },
     {
      "key": "NL",
      "name": "Mee eens"
     },
     {
      "key": "LA",
      "name": "Consentio"
     }
    ]
   },
   {
    "color": "#ff9000",
    "key": "3",
    "name": [
     {
      "key": "EN",
      "name": "Neutral"
     },
     {
      "key": "AR",
      "name": "محايد"
     },
     {
      "key": "ES",
      "name": "Ni de acuerdo ni en desacuerdo"
     },
     {
      "key": "FR",
      "name": "Neutre"
     },
     {
      "key": "DE",
      "name": "Neutral"
     },
     {
      "key": "NL",
      "name": "Neutraal"
     },
     {
      "key": "LA",
      "name": "Neutrum"
     }
    ]
   },
   {
    "color": "#ff9000",
    "key": "2",
    "name": [
     {
      "key": "EN",
      "name": "Disagree"
     },
     {
      "key": "AR",
      "name": "لا أوافق"
     },
     {
      "key": "ES",
      "name": "En desacuerdo"
     },
     {
      "key": "FR",
      "name": "Pas d’accord"
     },
     {
      "key": "DE",
      "name": "Stimme nicht zu"
     },
     {
      "key": "NL",
      "name": "Niet mee eens"
     },
     {
      "key": "LA",
      "name": "Dissentio"
     }
    ]
   },
   {
    "color": "#e64e4e",
    "key": "1",
    "name": [
     {
      "key": "EN",
      "name": "Strongly Disagree"
     },
     {
      "key": "AR",
      "name": "لا أوافق بشدة"
     },
     {
      "key": "ES",
      "name": "Totalmente en desacuerdo"
     },
     {
      "key": "FR",
      "name": "Pas du tout d’accord"
     },
     {
      "key": "DE",
      "name": "Stimme gar nicht zu"
     },
     {
      "key": "NL",
      "name": "Sterk mee oneens"
     },
     {
      "key": "LA",
      "name": "Fortiter dissentio"
     }
    ]
   },
   {
    "color": "#808080",
    "key": "0",
    "name": [
     {
      "key": "EN",
      "name": "N/A"
     },
     {
      "key": "AR",
      "name": "لا ينطبق"
     },
     {
      "key": "ES",
      "name": "N/A"
     },
     {
      "key": "FR",
      "name": "N/A"
     },
     {
      "key": "DE",
      "name": "N/A"
     },
     {
      "key": "NL",
      "name": "N/A"
     },
     {
      "key": "LA",
      "name": "N/A"
     }
    ]
   }
  ],
  "key": "single-answer-confidence-with-na"
 },
 {
  "Options": [
   {
    "key": "0",
    "name": [
     {
      "key": "EN",
      "name": "0"
     },
     {
      "key": "AR",
      "name": "0"
     }
    ]
   },
   {
    "key": "1",
    "name": [
     {
      "key": "EN",
      "name": "1"
     },
     {
      "key": "AR",
      "name": "1"
     }
    ]
   },
   {
    "key": "2",
    "name": [
     {
      "key": "EN",
      "name": "2"
     },
     {
      "key": "AR",
      "name": "2"
     }
    ]
   },
   {
    "key": "3",
    "name": [
     {
      "key": "EN",
      "name": "3"
     },
     {
      "key": "AR",
      "name": "3"
     }
    ]
   },
   {
    "key": "4",
    "name": [
     {
      "key": "EN",
      "name": "4"
     },
     {
      "key": "AR",
      "name": "4"
     }
    ]
   },
   {
    "key": "5",
    "name": [
     {
      "key": "EN",
      "name": "5"
     },
     {
      "key": "AR",
      "name": "5"
     }
    ]
   },
   {
    "key": "6",
    "name": [
     {
      "key": "EN",
      "name": "6"
     },
     {
      "key": "AR",
      "name": "6"
     }
    ]
   },
   {
    "key": "7",
    "name": [
     {
      "key": "EN",
      "name": "7"
     },
     {
      "key": "AR",
      "name": "7"
     }
    ]
   },
   {
    "key": "8",
    "name": [
     {
      "key": "EN",
      "name": "8"
     },
     {
      "key": "AR",
      "name": "8"
     }
    ]
   },
   {
    "key": "9",
    "name": [
     {
      "key": "EN",
      "name": "9"
     },
     {
      "key": "AR",
      "name": "9"
     }
    ]
   },
   {
    "key": "10",
    "name": [
     {
      "key": "EN",
      "name": "10"
     },
     {
      "key": "AR",
      "name": "10"
     }
    ]
   }
  ],
  "key": "single-answer-out-10"
 },
 {
  "Options": [
   {
    "color": "#73b504",
    "key": "ML",
    "name": [
     {
      "key": "EN",
      "name": "Most Liked"
     },
     {
      "key": "AR",
      "name": "الأكثر تفضيلًا"
     }
    ]
   },
   {
    "color": "#e64e4e",
    "key": "LL",
    "name": [
     {
      "key": "EN",
      "name": "Least Liked"
     },
     {
      "key": "AR",
      "name": "الأقل تفضيلًا"
     }
    ]
   }
  ],
  "key": "sub-questions-binary-likeness-rating"
 },
 {
  "Options": [
   {
    "color": "#3eb75b",
    "key": "STA",
    "name": [
     {
      "key": "EN",
      "name": "Strongly Agree"
     },
     {
      "key": "AR",
      "name": "أوافق بشدة"
     },
     {
      "key": "ES",
      "name": ""
     },
     {
      "key": "FR",
      "name": ""
     },
     {
      "key": "DE",
      "name": ""
     },
     {
      "key": "NL",
      "name": ""
     },
     {
      "key": "LA",
      "name": ""
     }
    ]
   },
   {
    "color": "#9dc62b",
    "key": "A",
    "name": [
     {
      "key": "EN",
      "name": "Agree"
     },
     {
      "key": "AR",
      "name": "أوافق"
     },
     {
      "key": "ES",
      "name": "De acuerdo"
     },
     {
      "key": "FR",
      "name": "D’accord"
     },
     {
      "key": "DE",
      "name": "Stimme zu"
     },
     {
      "key": "NL",
      "name": "Mee eens"
     },
     {
      "key": "LA",
      "name": "Consentio"
     }
    ]
   },
   {
    "color": "#ff9000",
    "key": "DA",
    "name": [
     {
      "key": "EN",
      "name": "Disagree"
     },
     {
      "key": "AR",
      "name": "لا أوافق"
     },
     {
      "key": "ES",
      "name": "En desacuerdo"
     },
     {
      "key": "FR",
      "name": "Pas d’accord"
     },
     {
      "key": "DE",
      "name": "Stimme nicht zu"
     },
     {
      "key": "NL",
      "name": "Niet mee eens"
     },
     {
      "key": "LA",
      "name": "Dissentio"
     }
    ]
   },
   {
    "color": "#ff9000",
    "key": "SDA",
    "name": [
     {
      "key": "EN",
      "name": "Strongly Disagree"
     },
     {
      "key": "AR",
      "name": "لا أوافق بشدة"
     },
     {
      "key": "ES",
      "name": "Totalmente en desacuerdo"
     },
     {
      "key": "FR",
      "name": "Pas du tout d’accord"
     },
     {
      "key": "DE",
      "name": "Stimme gar nicht zu"
     },
     {
      "key": "NL",
      "name": "Sterk mee oneens"
     },
     {
      "key": "LA",
      "name": "Fortiter dissentio"
     }
    ]
   },
   {
    "color": "#808080",
    "key": "NA",
    "name": [
     {
      "key": "EN",
      "name": "N/A"
     },
     {
      "key": "AR",
      "name": "لا ينطبق"
     },
     {
      "key": "ES",
      "name": ""
     },
     {
      "key": "FR",
      "name": ""
     },
     {
      "key": "DE",
      "name": ""
     },
     {
      "key": "NL",
      "name": ""
     },
     {
      "key": "LA",
      "name": ""
     }
    ]
   }
  ],
  "key": "sub-questions-confidence-na-rating"
 },
 {
  "Options": [
   {
    "color": "#3eb75b",
    "key": "STA",
    "name": [
     {
      "key": "EN",
      "name": "Strongly Agree"
     },
     {
      "key": "AR",
      "name": "أوافق بشدة"
     },
     {
      "key": "ES",
      "name": "Totalmente de acuerdo"
     },
     {
      "key": "FR",
      "name": "Tout à fait d’accord"
     },
     {
      "key": "DE",
      "name": "Stimme sehr zu"
     },
     {
      "key": "NL",
      "name": "Helemaal mee eens"
     },
     {
      "key": "LA",
      "name": "Fortiter consentio"
     }
    ]
   },
   {
    "color": "#9dc62b",
    "key": "A",
    "name": [
     {
      "key": "EN",
      "name": "Agree"
     },
     {
      "key": "AR",
      "name": "أوافق"
     },
     {
      "key": "ES",
      "name": "De acuerdo"
     },
     {
      "key": "FR",
      "name": "D’accord"
     },
     {
      "key": "DE",
      "name": "Stimme zu"
     },
     {
      "key": "NL",
      "name": "Mee eens"
     },
     {
      "key": "LA",
      "name": "Consentio"
     }
    ]
   },
   {
    "color": "#ff9000",
    "key": "DA",
    "name": [
     {
      "key": "EN",
      "name": "Disagree"
     },
     {
      "key": "AR",
      "name": "لا أوافق"
     },
     {
      "key": "ES",
      "name": "En desacuerdo"
     },
     {
      "key": "FR",
      "name": "Pas d’accord"
     },
     {
      "key": "DE",
      "name": "Stimme nicht zu"
     },
     {
      "key": "NL",
      "name": "Niet mee eens"
     },
     {
      "key": "LA",
      "name": "Dissentio"
     }
    ]
   },
   {
    "color": "#e64e4e",
    "key": "SDA",
    "name": [
     {
      "key": "EN",
      "name": "Strongly Disagree"
     },
     {
      "key": "AR",
      "name": "لا أوافق بشدة"
     },
     {
      "key": "ES",
      "name": "Totalmente en desacuerdo"
     },
     {
      "key": "FR",
      "name": "Pas du tout d’accord"
     },
     {
      "key": "DE",
      "name": "Stimme gar nicht zu"
     },
     {
      "key": "NL",
      "name": "Sterk mee oneens"
     },
     {
      "key": "LA",
      "name": "Fortiter dissentio"
     }
    ]
   }
  ],
  "key": "sub-questions-confidence-rating"
 },
 {
  "Options": [
   {
    "color": "#3eb75b",
    "key": "EF",
    "name": [
     {
      "key": "EN",
      "name": "Extremely Fair"
     },
     {
      "key": "AR",
      "name": "ممتاز"
     }
    ]
   },
   {
    "color": "#73b504",
    "key": "MF",
    "name": [
     {
      "key": "EN",
      "name": "Moderately Fair"
     },
     {
      "key": "AR",
      "name": "جيد"
     }
    ]
   },
   {
    "color": "#e64e4e",
    "key": "MUF",
    "name": [
     {
      "key": "EN",
      "name": "Moderately Unfair"
     },
     {
      "key": "AR",
      "name": "مقبول"
     }
    ]
   },
   {
    "color": "#808080",
    "key": "EUF",
    "name": [
     {
      "key": "EN",
      "name": "Extremely Unfair"
     },
     {
      "key": "AR",
      "name": "ضعيف"
     }
    ]
   }
  ],
  "key": "sub-questions-fairness-degree"
 },
 {
  "Options": [
   {
    "color": "#3eb75b",
    "key": "EF",
    "name": [
     {
      "key": "EN",
      "name": "Extremely Fair"
     },
     {
      "key": "AR",
      "name": "ممتاز"
     }
    ]
   },
   {
    "color": "#73b504",
    "key": "MF",
    "name": [
     {
      "key": "EN",
      "name": "Moderately Fair"
     },
     {
      "key": "AR",
      "name": "جيد"
     }
    ]
   },
   {
    "color": "#e64e4e",
    "key": "MUF",
    "name": [
     {
      "key": "EN",
      "name": "Moderately Unfair"
     },
     {
      "key": "AR",
      "name": "مقبول"
     }
    ]
   },
   {
    "color": "#808080",
    "key": "EUF",
    "name": [
     {
      "key": "EN",
      "name": "Extremely Unfair"
     },
     {
      "key": "AR",
      "name": "ضعيف"
     }
    ]
   },
   {
    "color": "#808080",
    "key": "NA",
    "name": [
     {
      "key": "EN",
      "name": "N/A"
     },
     {
      "key": "AR",
      "name": "لا ينطبق"
     }
    ]
   }
  ],
  "key": "sub-questions-fairness-degree-na-rating"
 },
 {
  "Options": [
   {
    "color": "#3eb75b",
    "key": "EX",
    "name": [
     {
      "key": "EN",
      "name": "Excellent"
     },
     {
      "key": "AR",
      "name": "ممتاز"
     }
    ]
   },
   {
    "color": "#73b504",
    "key": "G",
    "name": [
     {
      "key": "EN",
      "name": "Good"
     },
     {
      "key": "AR",
      "name": "جيد"
     }
    ]
   },
   {
    "color": "#ff9000",
    "key": "F",
    "name": [
     {
      "key": "EN",
      "name": "Fair"
     },
     {
      "key": "AR",
      "name": "مقبول"
     }
    ]
   },
   {
    "color": "#e64e4e",
    "key": "P",
    "name": [
     {
      "key": "EN",
      "name": "Poor"
     },
     {
      "key": "AR",
      "name": "ضعيف"
     }
    ]
   },
   {
    "color": "#808080",
    "key": "NA",
    "name": [
     {
      "key": "EN",
      "name": "N/A"
     },
     {
      "key": "AR",
      "name": "لا ينطبق"
     }
    ]
   }
  ],
  "key": "sub-questions-likeness-na-rating"
 },
 {
  "Options": [
   {
    "color": "#3eb75b",
    "key": "EX",
    "name": [
     {
      "key": "EN",
      "name": "Excellent"
     },
     {
      "key": "AR",
      "name": "ممتاز"
     }
    ]
   },
   {
    "color": "#73b504",
    "key": "G",
    "name": [
     {
      "key": "EN",
      "name": "Good"
     },
     {
      "key": "AR",
      "name": "جيد"
     }
    ]
   },
   {
    "color": "#ff9000",
    "key": "F",
    "name": [
     {
      "key": "EN",
      "name": "Fair"
     },
     {
      "key": "AR",
      "name": "مقبول"
     }
    ]
   },
   {
    "color": "#e64e4e",
    "key": "P",
    "name": [
     {
      "key": "EN",
      "name": "Poor"
     },
     {
      "key": "AR",
      "name": "ضعيف"
     }
    ]
   }
  ],
  "key": "sub-questions-likeness-rating"
 }
]